import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlatinum = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 80,
	viewBox: "0 0 60 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 12.4341C0 5.56695 5.56696 0 12.4341 0H47.5659C54.433 0 60 5.56696 60 12.4341V50C60 66.5685 46.5685 80 30 80C13.4315 80 0 66.5685 0 50V12.4341Z",
			fill: "#B5B5C4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 12.9713C2 7.18817 6.68817 2.5 12.4713 2.5H47.5287C53.3118 2.5 58 7.18817 58 12.9713V50C58 65.464 45.464 78 30 78C14.536 78 2 65.464 2 50V12.9713Z",
			fill: "url(#paint0_linear_2038_315427)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 21.8982C4.5 17.8123 7.81231 14.5 11.8982 14.5H48.1018C52.1877 14.5 55.5 17.8123 55.5 21.8982V50C55.5 64.0833 44.0833 75.5 30 75.5C15.9167 75.5 4.5 64.0833 4.5 50V21.8982Z",
			fill: "url(#paint1_linear_2038_315427)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			y: 7.5,
			width: 20,
			height: 2,
			rx: 1,
			fill: "#92929A"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2038_315427)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_2038_315427",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 2,
				y: 13,
				width: 80,
				height: 79,
				children: /* @__PURE__ */ _jsx("rect", {
					x: 57,
					y: 13,
					width: 35,
					height: 76.5,
					transform: "rotate(45 57 13)",
					fill: "black"
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_2038_315427)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M4.5 21.8982C4.5 17.8123 7.81231 14.5 11.8982 14.5H48.1018C52.1877 14.5 55.5 17.8123 55.5 21.8982V50C55.5 64.0833 44.0833 75.5 30 75.5C15.9167 75.5 4.5 64.0833 4.5 50V21.8982Z",
					fill: "black",
					fillOpacity: .3
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0029 49.0558V40.1895L39.9124 53.7498L30.0029 49.0558Z",
			fill: "#C0CBE0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.9124 53.7498L30.0029 40.1895L38.3478 42.7972L39.9124 53.7498Z",
			fill: "#7289B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.3478 42.7974L30.0029 40.1896L46.171 34.9741L38.3478 42.7974Z",
			fill: "#8EA3CB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.2184 33.4097L30.0029 40.1898L46.171 34.9743L35.2184 33.4097Z",
			fill: "#C0CBE0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0023 40.1897V23.5L35.2178 33.4095L30.0023 40.1897Z",
			fill: "#8EA3CB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0029 49.0558V40.1895L20.0934 53.7498L30.0029 49.0558Z",
			fill: "#8EA3CB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0934 53.7498L30.0029 40.1895L21.6581 42.7972L20.0934 53.7498Z",
			fill: "#E1F1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6581 42.7974L30.0029 40.1896L13.8348 34.9741L21.6581 42.7974Z",
			fill: "#7289B6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.7874 33.4097L30.0029 40.1898L13.8348 34.9743L24.7874 33.4097Z",
			fill: "#C0CBE0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0036 40.1897V23.5L24.7881 33.4095L30.0036 40.1897Z",
			fill: "#E1F1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2715 57.4495C29.4592 56.6892 30.5401 56.6892 30.7278 57.4495L31.1285 59.0727C31.1953 59.3432 31.4064 59.5544 31.6769 59.6211L33.3001 60.0219C34.0604 60.2096 34.0604 61.2904 33.3001 61.4781L31.6769 61.8789C31.4064 61.9456 31.1953 62.1568 31.1285 62.4272L30.7278 64.0505C30.5401 64.8108 29.4592 64.8108 29.2715 64.0505L28.8708 62.4272C28.804 62.1568 28.5928 61.9456 28.3224 61.8789L26.6992 61.4781C25.9388 61.2904 25.9388 60.2096 26.6992 60.0219L28.3224 59.6211C28.5928 59.5544 28.804 59.3432 28.8708 59.0727L29.2715 57.4495Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2038_315427",
				x1: 3.12,
				y1: 4.49908,
				x2: 17.7395,
				y2: 57.3032,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#F9F9F9" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .463542,
						stopColor: "#A6A5B3"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .898838,
						stopColor: "#D9D9DF"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2038_315427",
				x1: 30,
				y1: 14.5,
				x2: 30,
				y2: 75.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#93939A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#2D2D37"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_2038_315427",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 51,
					height: 61,
					fill: "white",
					transform: "translate(4.5 14.5)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgPlatinum);
export { ForwardRef as ReactComponent };
